import { styled } from "styled-components";
import { Dropdown, MenuItem } from "@icg360/ui-toolkit";
import { theme } from "@icg360/design-system";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${theme.colors.border.control};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

export const MortgageeName = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  font-size: 16px;
  font-weight: 500;
`;

export const MortgageeAddress = styled.div`
  padding-right: 40px;
`;

export const StyledSearchField = styled.div<{ $isQTC: boolean }>`
  position: relative;

  // DS applies a fixed height to all input elements.
  // This override is needed currently to match the styles of the surrounding inputs in our QTC form.
  // We can remove this once we fully switch to DS.
  .h-3xl {
    ${({ $isQTC }) => $isQTC && "height: 34px;"}
  }

  input,
  .dropdown-menu {
    min-width: 200px;
    width: 100%;
  }
`;

interface DropdownMenuProps {
  open: boolean;
  $isQTC: boolean;
}

export const DropdownMenu = styled(Dropdown.Menu)<DropdownMenuProps>`
  display: ${({ open }) => (open ? "block" : "none")};
  z-index: 1000;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 314px;

  li > a {
    padding: 12px 24px 6px;
  }
`;

export const DropdownSuggestion = styled(MenuItem)`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

export const DropdownAction = styled(MenuItem)`
  border-top: 1px solid ${theme.colors.border.control};

  && {
    a {
      display: flex;
      gap: ${theme.spacing.sm};
      background-color: ${theme.colors.fill.canvas};
      padding-bottom: ${theme.spacing.md};
    }
  }
`;

export const SearchError = styled.div`
  padding: ${theme.spacing.lg};
  color: ${theme.colors.text.danger};
`;

export const StyledSpinner = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.md};
`;
